import { POST, SUCCESS, FAILURE } from "../../utils/const/http-const";
import { getHeaders } from "../utils";
import { GET } from "../../utils/const/http-const";

export async function obtenerInfoEmpresa() {
    try {
        let response = {};
        const { code, body } = await fetch(
            "https://gestiondeflota.boltrack.net/apirastreogestion/api/empresa/",
            {
                headers: getHeaders(),
                method: GET,
                // body: JSON.stringify({data: 'hello'}),
            }
        ).then((res) => res.json());
        if (code === SUCCESS && Array.isArray(body) === true && body.length > 0) {
            response = body[0];
        }
        return response;
    } catch (err) {
        console.log("obtenerListaChecklist err");
        console.log(err);
        return {};
    }
}

export async function obtenerInfoEmpresaExterno(obj) {
    try {
        let response = "";
        const { code, body } = await fetch(
            "https://gestiondeflota.boltrack.net/apichecklistv2/api/empresa/obtener-info-empresa-externo",
            {
                headers: getHeaders(false),
                method: POST,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            response = body;
        }
        return response;
    } catch (err) {
        console.log("obtenerListaChecklist err");
        console.log(err);
        return "";
    }
}

export async function obtenerListaGrupos() {
    try {
        let response = { error: true };
        const { code, body, message } = await fetch(
            "https://gestiondeflota.boltrack.net/apirastreogestion/api/grupo/obtener-options-grupos-empresa",
            {
                headers: getHeaders(),
                method: GET,
                // body: JSON.stringify({data: 'hello'}),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        // console.log('message');
        // console.log(message);
        if (code === SUCCESS && Array.isArray(body) === true && body.length > 0) {
            response.error = false;
            response.data = body;
        }
        if (code === FAILURE) {
            response.error = true;
            response.message = message;
        }
        return response;
    } catch (err) {
        console.log("obtenerListaGrupos err");
        console.log(err);
        return { error: true, message: err };
    }
}

export async function obtenerListaSubGrupos(obj) {
    try {
        let response = { error: true };
        const { code, body, message } = await fetch(
            "https://gestiondeflota.boltrack.net/apirastreogestion/api/subgrupo/obtener-options-subgrupos-grupo",
            {
                headers: getHeaders(),
                method: POST,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        // console.log('message');
        // console.log(message);
        if (code === SUCCESS && Array.isArray(body) === true && body.length > 0) {
            response.error = false;
            response.data = body;
        }
        if (code === FAILURE) {
            response.error = true;
            response.message = message;
        }
        return response;
    } catch (err) {
        console.log("obtenerListaGrupos err");
        console.log(err);
        return { error: true, message: err };
    }
}